const GENDERS = [
  'male',
  'female',
  'other',
  'prefer_not_to_say'
];

export default GENDERS;
